import { apiFetch } from "./client";
import type { DirectorSummary } from "./types";

/**
 * S5 Homes — Director Home. The org-wide read-only business summary rides on
 * /home-summary?scope=all (backend embeds `directorSummary` only for a director /
 * admin_data_all / super-admin; otherwise the key is absent → null here, and the
 * gate falls back to the user's own surface — AC-SH-SCOPE-003).
 */
export async function fetchDirectorSummary(
  signal?: AbortSignal,
): Promise<DirectorSummary | null> {
  const res = await apiFetch<{ directorSummary?: DirectorSummary }>(
    "/Custom/frontend/home-summary",
    { query: { scope: "all" }, signal },
  );
  return res.directorSummary ?? null;
}
